import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                   // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true               // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect           // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'             // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    noCache: true                // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'               // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'             // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false            // 如果设置为false，则不会在breadcrumb面包屑中显示
  }
 */

// 公共路由
export const constantRoutes = [
  { path:'/crm/customer/detail',component:Layout,hidden:true,children:[{path:':id',component:()=>import('@/views/crm/customer/detail'),name:'CustomerDetailRead',meta:{title:'客户详情',noCache:true}}]},
  { path:'/crm/contact/detail',component:Layout,hidden:true,children:[{path:':id',component:()=>import('@/views/crm/contact/detail'),name:'ContactDetailRead',meta:{title:'联系人详情',noCache:true}}]},
  { path:'/oa/related-approval',component:Layout,hidden:true,children:[{path:':id',component:()=>import('@/views/oa/relatedApproval'),name:'RelatedApprovalDetail',meta:{title:'关联审批单详情',noCache:true}}]},
  { path:'/crm/contract/detail',component:Layout,hidden:true,children:[{path:':id',component:()=>import('@/views/crm/contract/detail'),name:'ContractDetailRead',meta:{title:'合同详情',noCache:true}}]},
  { path:'/crm/business/detail',component:Layout,hidden:true,children:[{path:':id',component:()=>import('@/views/crm/business/detail'),name:'BusinessDetailRead',meta:{title:'商机详情',noCache:true}}]},
  { path: '/crm/monthly-appraisal', component: Layout, hidden: true, children: [
    { path: '', component: () => import('@/views/crm/kpi/monthlyAppraisal'), name: 'MonthlyAppraisal', meta: { title: '月度绩效考核', noCache: true } }
  ] },
  { path: '/index', redirect: '/workbench', hidden: true },
  { path: '/crm/index', redirect: '/workbench', hidden: true },
  { path: '/finance/applications', component: Layout, hidden: true, children: [
    { path: ':type/edit', component: () => import('@/views/oa/financeApplication'), name: 'FinanceApplicationEdit', meta: { title: '财务申请', noCache: true } },
    { path: ':type/detail/:id', component: () => import('@/views/oa/financeApplication'), name: 'FinanceApplicationDetail', meta: { title: '申请详情', noCache: true } },
    { path: ':type', component: () => import('@/views/oa/financeApplication'), name: 'FinanceApplicationList', meta: { title: '财务申请', noCache: true } }
  ] },
  {path:'/oa/business/:type',component:Layout,hidden:true,children:[
    {path:'',component:()=>import('@/views/oa/businessApplication'),name:'OaBusinessList',meta:{title:'我的业务申请',noCache:true}},
    {path:'edit',component:()=>import('@/views/oa/businessApplication'),name:'OaBusinessEdit',meta:{title:'发起业务申请',noCache:true}},
    {path:'detail/:id',component:()=>import('@/views/oa/businessApplication'),name:'OaBusinessDetail',meta:{title:'业务申请详情',noCache:true}}
  ]},
  { path: '/finance/expense-claims', redirect: '/oa/expense-claims', hidden: true },
  {
    path: '/finance/expense', component: Layout, hidden: true,
    children: [
      { path: 'edit', component: () => import('@/views/crm/expense/form'), name: 'ExpenseClaimEdit', meta: { title: '报销申请', noCache: true } },
      { path: 'detail/:id', component: () => import('@/views/crm/expense/detail'), name: 'ExpenseClaimDetail', meta: { title: '报销详情', noCache: true } }
    ]
  },

  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: (resolve) => require(['@/views/redirect'], resolve)
      }
    ]
  },
  {
    path: '/login',
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/error/404'], resolve),
    hidden: true
  },
  {
    path: '/401',
    component: (resolve) => require(['@/views/error/401'], resolve),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/workbench',
    children: [
      {
        path: 'workbench',
        component: (resolve) => require(['@/views/index'], resolve),
        name: 'Workbench',
        meta: { title: '工作台', icon: 'dashboard', noCache: true, affix: true }
      }
    ]
  },

  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: (resolve) => require(['@/views/system/user/profile/index'], resolve),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  {
    path: '/toolbox',
    component: Layout,
    hidden: true,
    redirect: '/toolbox/invoice-tax',
    children: [
      {
        path: 'invoice-tax',
        component: (resolve) => require(['@/views/toolbox/index'], resolve),
        name: 'InvoiceTaxTool',
        meta: { title: '工具箱', icon: 'tool', noCache: true }
      }
    ]
  },
  {
    path: '/message-center',
    component: Layout,
    hidden: true,
    children: [{
      path: '',
      component: (resolve) => require(['@/views/message-center/index'], resolve),
      name: 'ApprovalMessageCenter',
      meta: { title: '消息中心', icon: 'message', noCache: true }
    }]
  },
  {
    path: '/assetManagement/assetRepairApproval/:id',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/asset/approval'], resolve),
        name: 'AssetRepairApproval',
        meta: { title: '资产报废审批', icon: 'form', noCache: true }
      }
    ]
  },
  {
    path: '/crm/procurement',
    redirect: '/procurement/workbench',
    hidden: true
  },
  {
    path: '/crm/procurement/workbench',
    redirect: '/procurement/workbench',
    hidden: true
  },
  {
    path: '/procurement/workbench',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/procurement/index'], resolve),
        name: 'ProcurementWorkbench',
        meta: { title: '采购工作台', icon: 'dashboard', noCache: true }
      }
    ]
  },
  {
    path: '/crm/procurement/apply',
    redirect: '/procurement/apply',
    hidden: true
  },
  {
    path: '/procurement/apply',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/procurement/index'], resolve),
        name: 'ProcurementApplyList',
        meta: { title: '采购申请', icon: 'list', noCache: true }
      }
    ]
  },
  {
    path: '/procurement/order',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/procurement/index'], resolve),
        name: 'ProcurementOrderList',
        meta: { title: '采购执行单', icon: 'list', noCache: true }
      }
    ]
  },
  {
    path: '/procurement/todo',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/procurement/index'], resolve),
        name: 'ProcurementTodoList',
        meta: { title: '采购待处理', icon: 'list', noCache: true }
      }
    ]
  },
  {
    path: '/crm/procurement/apply/detail/:id',
    redirect: to => ({ path: `/procurement/apply/detail/${to.params.id}` }),
    hidden: true
  },
  {
    path: '/procurement/apply/new',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/procurement/index'], resolve),
        name: 'ProcurementApplyNew',
        meta: { title: '新增采购申请', icon: 'shopping', noCache: true }
      }
    ]
  },
  {
    path: '/procurement/contracts', component: Layout, hidden: true,
    children: [
      { path: '', component: () => import('@/views/oa/purchaseContractApproval'), name: 'PurchaseContractApplications', meta: { title: '我的采购合同申请', noCache: true } },
      { path: 'edit', component: () => import('@/views/oa/purchaseContractApproval'), name: 'PurchaseContractEdit', meta: { title: '发起采购合同审批', noCache: true } },
      { path: 'detail/:id', component: () => import('@/views/oa/purchaseContractApproval'), name: 'PurchaseContractDetail', meta: { title: '采购合同审批', noCache: true } }
    ]
  },
  {
    path: '/procurement/apply/detail/:id',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/procurement/index'], resolve),
        name: 'ProcurementApplyDetail',
        meta: { title: '采购详情', icon: 'shopping', noCache: true }
      }
    ]
  },
  {
    path: '/crm/procurement/report',
    redirect: '/procurement/report',
    hidden: true
  },
  {
    path: '/procurement/report',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/procurement/index'], resolve),
        name: 'ProcurementReport',
        meta: { title: '采购报表', icon: 'chart', noCache: true }
      }
    ]
  },
  {
    path: '/crm/procurement/supplier',
    redirect: '/procurement/supplier',
    hidden: true
  },
  {
    path: '/procurement/supplier',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/procurement/index'], resolve),
        name: 'ProcurementSupplier',
        meta: { title: '供应商库', icon: 'people', noCache: true }
      }
    ]
  },
  {
    path: '/crm/procurement/price',
    redirect: '/procurement/price',
    hidden: true
  },
  {
    path: '/procurement/price',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: (resolve) => require(['@/views/crm/procurement/index'], resolve),
        name: 'ProcurementPrice',
        meta: { title: '价格库', icon: 'money', noCache: true }
      }
    ]
  },
  {
    path: '/dict',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'type/data/:dictId(\\d+)',
        component: (resolve) => require(['@/views/system/dict/data'], resolve),
        name: 'Data',
        meta: { title: '字典数据', icon: '' }
      }
    ]
  },
  {
    path: '/job',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'log',
        component: (resolve) => require(['@/views/monitor/job/log'], resolve),
        name: 'JobLog',
        meta: { title: '调度日志' }
      }
    ]
  },
  {
    path: '/gen',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'edit/:tableId(\\d+)',
        component: (resolve) => require(['@/views/tool/gen/editTable'], resolve),
        name: 'GenEdit',
        meta: { title: '修改生成配置' }
      }
    ]
  },
  // {
  //   path: '/saas',
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '数据概况' },
  //   children: [
  //     {
  //       path: 'index',
  //       component: (resolve) => require(['@/views/saas/manage/survey'], resolve),
  //       name: '数据概况',
  //       meta: { title: '数据概况', icon: 'dashboard', noCache: true, affix: true }
  //     },
  //     {
  //       path: 'detail',
  //       component: (resolve) => require(['@/views/saas/manage/index'], resolve),
  //       name: '套餐情况',
  //       meta: { title: '套餐情况', icon: 'dashboard', noCache: true, affix: true }
  //     },{
  //       path: 'statistics',
  //       component: (resolve) => require(['@/views/saas/manage/statistics'], resolve),
  //       name: '营销统计',
  //       meta: { title: '营销统计', icon: 'dashboard', noCache: true, affix: true }
  //     },
  //   ]
  // },
  // {
  //   path: '/system',
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '数据概况' },
  //   children: [
  //     {
  //       path: 'index',
  //       component: (resolve) => require(['@/views/saas/operate/index'], resolve),
  //       name: '数据概况',
  //       meta: { title: '数据概况', icon: 'dashboard', noCache: true, affix: true }
  //     },
  //   ]
  // },
  // {
  //   path: '/package',
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '公文包' },
  //   children: [
  //     {
  //       path: 'manageMember',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/manageMember'], resolve),
  //       name: 'manageMember',
  //       meta: { title: '成员管理' }
  //     }
  //   ]
  // },
  // {
  //   path: '/package',
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '企业公文包' },
  //   children: [
  //     {
  //       path: 'decorate',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/decorate'], resolve),
  //       name: 'decorate',
  //       redirect: '/decorate',
  //       meta: { title: '企业官网' }
  //     },
  //     {
  //       path: 'card',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/card'], resolve),
  //       name: 'card',
  //       redirect: '/card',
  //       meta: { title: '名片设置' }
  //     },
  //     {
  //       path: 'product',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/product'], resolve),
  //       name: 'product',
  //       meta: { title: '产品介绍' }
  //     },
  //     {
  //       path: 'case',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/case'], resolve),
  //       name: 'case',
  //       meta: { title: '案例介绍' }
  //     },
  //     {
  //       path: 'article',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/article'], resolve),
  //       name: 'article',
  //       meta: { title: '文章管理' }
  //     },
  //     {
  //       path: 'articleDetail',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/articleDetail'], resolve),
  //       name: 'articleDetail',
  //       hidden: true,
  //       meta: { title: '文章详情' }
  //     },
  //     {
  //       path: 'record',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/record'], resolve),
  //       name: 'record',
  //       meta: { title: '互动咨询' }
  //     },
  //     {
  //       path: 'info',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/info'], resolve),
  //       name: 'info',
  //       meta: { title: '企业信息' }
  //     },
  //     {
  //       path: 'recordDetail',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/recordDetail'], resolve),
  //       name: 'recordDetail',
  //       hidden: true,
  //       meta: { title: '咨询详情' }
  //     },
  //     {
  //       path: 'library',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/library'], resolve),
  //       name: 'library',
  //       meta: { title: '文件库' }
  //     },
  //     // {
  //     //   path: 'notice',
  //     //   component: (resolve) => require(['@/views/saas/manage/briefcase/notice'], resolve),
  //     //   name: 'notice',
  //     //   meta: { title: '公司公告' }
  //     // },
  //
  //     {
  //       path: 'comment',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/comment'], resolve),
  //       name: 'comment',
  //       meta: { title: '评论管理' }
  //     }
  //   ]
  // },
  // {
  //   path: '/latent',
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '潜在联系人' },
  //   children: [
  //     {
  //       path: 'contacts',
  //       component: (resolve) => require(['@/views/saas/manage/contacts/contacts'], resolve),
  //       name: 'contacts',
  //       meta: { title: '潜在联系人' }
  //     }
  //     ,{
  //       path: 'contactDetail',
  //       component: (resolve) => require(['@/views/saas/manage/contacts/contactDetail'], resolve),
  //       name: 'contactDetail',
  //       hidden: true,
  //       meta: { title: '潜在联系人详情' }
  //     }
  //   ]
  // },

  // {
  //   path: '/system',
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: 'SAAS系统管理' },
  //   children: [
  //     {
  //       path: 'apply',
  //       component: (resolve) => require(['@/views/saas/operate/system/apply'], resolve),
  //       name: 'apply',
  //       meta: { title: '入驻申请' }
  //     }
      // {
      //   path: 'package',
      //   component: (resolve) => require(['@/views/saas/operate/system/package/package'], resolve),
      //   name: 'package',
      //   meta: { title: '套餐管理' }
      // },{
      //   path: 'notice',
      //   component: (resolve) => require(['@/views/saas/manage/briefcase/notice'], resolve),
      //   name: 'notice',
      //   meta: { title: '系统公告' }
      // },{
      //   path: 'tenant',
      //   component: (resolve) => require(['@/views/saas/operate/system/tenant/tenant'], resolve),
      //   name: 'tenant',
      //   meta: { title: '租户管理' }
      // }
      // ,{
      //   path: 'noticeDetail',
      //   component: (resolve) => require(['@/views/saas/manage/briefcase/noticeDetail'], resolve),
      //   name: 'noticeDetail',
      //   hidden: true,
      //   meta: { title: '公告详情' }
      // }
      // ,{
      //   path: 'addPackage',
      //   component: (resolve) => require(['@/views/saas/operate/system/package/addPackage'], resolve),
      //   name: 'addPackage',
      //   hidden: true,
      //   meta: { title: '添加套餐' }
      // },{
      //   path: 'packageDetail',
      //   component: (resolve) => require(['@/views/saas/operate/system/package/packageDetail'], resolve),
      //   name: 'packageDetail',
      //   hidden: true,
      //   meta: { title: '套餐详情' }
      // },{
      //   path: 'addTenantPackage',
      //   component: (resolve) => require(['@/views/saas/operate/system/tenant/addTenantPackage'], resolve),
      //   name: 'addTenantPackage',
      //   hidden: true,
      //   meta: { title: '添加套餐' }
      // },{
      //   path: 'tenantDetail',
      //   component: (resolve) => require(['@/views/saas/operate/system/tenant/tenantDetail'], resolve),
      //   name: 'tenantDetail',
      //   hidden: true,
      //   meta: { title: '租户详情' }
      // }
  //   ]
  // },
  // {
  //   path: '/hydrosp',
  //   component: Layout,
  //   hidden: false,
  //   meta: { title: '水圈管理' },
  //   children: [
  //     {
  //       path: 'hydrospArticle',
  //       component: (resolve) => require(['@/views/saas/operate/hydrosp/hydrospArticle'], resolve),
  //       name: 'hydrospArticle',
  //       meta: { title: '水圈文章' }
  //     },{
  //       path: 'businessArticle',
  //       component: (resolve) => require(['@/views/saas/operate/hydrosp/businessArticle'], resolve),
  //       name: 'businessArticle',
  //       meta: { title: '企业文章' }
  //     },{
  //       path: 'businessArticleDetail',
  //       component: (resolve) => require(['@/views/saas/operate/hydrosp/businessArticleDetail'], resolve),
  //       name: 'businessArticleDetail',
  //       hidden: true,
  //       meta: { title: '企业文章详情' }
  //     },{
  //       path: 'hydrospComment',
  //       component: (resolve) => require(['@/views/saas/manage/briefcase/comment'], resolve),
  //       name: 'hydrospComment',
  //       meta: { title: '评论管理' }
  //     },{
  //       path: 'businessManage',
  //       component: (resolve) => require(['@/views/saas/operate/hydrosp/businessManage'], resolve),
  //       name: 'businessManage',
  //       meta: { title: '企业管理' }
  //     }
  //   ]
  // },
  // 官网装修
  {
    path: '/briefcase/officialWebsite',
    hidden: true,
    component: (resolve) => require(['@/views/saas/manage/briefcase/decorate'], resolve),
    meta: { title: '官网编辑' }
  },
  // 个人名片
  {
    path: '/briefcase/businessCard',
    hidden: true,
    component: (resolve) => require(['@/views/saas/manage/briefcase/card'], resolve),
    meta: { title: '名片设置' }
  }
]

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
